import React from "react";

function SixSection() {
  return (
    <div className="sixth">
      <div className="sixth-bg">
        <div className="sixth-g">
          <div>
            <h1 className="style-heading">Prefessional!</h1>
            <p>
              <b>Product Price</b>
            </p>
            <br />
            <h1 className="price">
              <small>$</small>49.<small>99</small>
            </h1>
            <br />
            <p>
              <b>Overview</b>
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro
              eaque labore ullam sint voluptatum exercitationem quisquam,
              distinctio ipsa excepturi tempore. Lorem ipsum dolor sit amet
              consectetur adipisicing elit. Porro eaque labore ullam sint
            </p>
            <br />
          </div>
        </div>
        <div className="sixth-w">
          <div className="our-best">
            <h1>Our Best</h1>
            <p>
              <b>Seavices</b>
            </p>
            <br />
            <ul>
              <li>Lorem ipsum dolor sit amet consectetu</li>
              <li>Lorem ipsum dolor st amet consectetu</li>
              <li>Lorem ipsum dolor amet consectetu</li>
              <li>Lorem ipsum dolor sit amet consectetu</li>
              <li>Lorem idolor sit amet consectetu</li>
            </ul>
            <br />
            <br />
            <button>Learn More</button>
          </div>
          <div className="sixth-text">
            <h1 className="style-heading">
              Take Your Wealth
              <br />
              to the Next Level
            </h1>
            <br />
            <br />
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro
              eaque labore ullam sint voluptatum exercitationem quisquam,
              distinctio ipsa excepturi tempore. Lorem ipsum dolor sit amet
              consectetur adipisicing elit. Porro eaque labore ullam sint
            </p>
            <br />
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro
              eaque labore ullam sint voluptatum exercitationem quisquam,
              distinctio ipsa excepturi tempore. Lorem ipsum dolor sit amet
              consectetur adipisicing elit. Porro eaque labore ullam sint
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SixSection;
